import React from "react";

export default function Container({ children }) {
  return (
    <div className="main-slider">
      <div className="padding-tbl-monitoring">{children}</div>
    </div>
  );
}
